import "./CampaignResultPanel.css";
import "./MessagingButtons.css";
import {
  SendCampaignResult,
} from "../../../models/MessageModels";
import MessageStatusBadge from "./MessageStatusBadge";
import WhatsAppOpenButton from "./WhatsAppOpenButton";

interface CampaignResultPanelProps {
  result: SendCampaignResult;
  onViewCampaign: (campaignId: string) => void;
}

const CampaignResultPanel = ({
  result,
  onViewCampaign,
}: CampaignResultPanelProps) => {
  const openItems = result.items.filter((item) => item.whatsAppUrl);

  return (
    <div className="msg-result">
      <div className="msg-result__summary">
        <div className="msg-result__card">
          <span className="msg-result__value">{result.totalCount}</span>
          <span className="msg-result__label">Total</span>
        </div>
        <div className="msg-result__card msg-result__card--success">
          <span className="msg-result__value">{result.successCount}</span>
          <span className="msg-result__label">Sent</span>
        </div>
        <div className="msg-result__card msg-result__card--failed">
          <span className="msg-result__value">{result.failCount}</span>
          <span className="msg-result__label">Failed</span>
        </div>
      </div>

      <p className="msg-result__note">
        Recipients are marked <strong>Sent</strong> (message prepared /
        WhatsApp opened). To avoid opening dozens of tabs, open the WhatsApp
        links one at a time below. True bulk WhatsApp delivery needs a
        provider integration later.
      </p>

      {openItems.length > 0 && (
        <div className="msg-result__links">
          <span className="msg-result__links-title">
            Open WhatsApp for recipients
          </span>
          <div className="msg-result__links-scroll">
            {openItems.map((item) => (
              <div key={item.logId || item.whatsAppUrl} className="msg-result__link-row">
                <WhatsAppOpenButton url={item.whatsAppUrl as string} />
                <MessageStatusBadge status={item.status} />
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="msg-result__actions">
        <button
          className="msg-btn msg-btn--primary"
          onClick={() => onViewCampaign(result.campaignId)}
        >
          View campaign details
        </button>
      </div>
    </div>
  );
};

export default CampaignResultPanel;